<template>
<div>
  <el-dialog
    title="班级详情"
    :visible.sync="dialogVisible"
    width="90%"
    top="60px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
      @clearAll="onSearch"
    />
    <div class="btns">
      <el-button v-if="$hasAuthority('tvoperate_importApply')" size='mini' type="primary" icon="el-icon-edit" @click="importSignTable(1)">导入报名表</el-button>
      <el-button v-if="$hasAuthority('tvoperate_importConformity')" size='mini' type="primary" icon="el-icon-edit" @click="importSignTable(2)">导入合格证</el-button>
      <template v-if="showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_exportConformity_all')" size='mini' type="primary" icon="el-icon-edit" @click="dcAll(2)">导出全部合格证信息</el-button>
        <el-button v-if="$hasAuthority('tvoperate_exportCredential_all')" size='mini' type="primary" icon="el-icon-edit" @click="dcAll(1)">导出全部结业证信息</el-button>
      </template>
      <template v-if="!showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_exportConformity_more')" size='mini' type="primary" icon="el-icon-edit" @click="pldc(2)">合格证信息批量导出</el-button>
        <el-button v-if="$hasAuthority('tvoperate_exportCredential_more')" size='mini' type="primary" icon="el-icon-edit" @click="pldc(1)">结业证书信息批量导出</el-button>
      </template>
    </div>
    <div class="btns">
      <template v-if="showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_awardConformity_all')" size='mini' type="primary" icon="el-icon-edit" @click="plBfAll">颁发全部合格证</el-button>
        <el-button v-if="$hasAuthority('tvoperate_awardCredential_all')" size='mini' type="primary" icon="el-icon-edit" @click="awardGraduationAll">颁发全部结业证</el-button>
      </template>
      <template v-if="!showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_awardConformity_more')" size='mini' type="primary" icon="el-icon-edit" @click="plBf">批量颁发合格证</el-button>
        <el-button v-if="$hasAuthority('tvoperate_awardCredential_more')" size='mini' type="primary" icon="el-icon-edit" @click="awardGraduation">批量颁发结业证书</el-button>
      </template>
    </div>
    <c-table
        v-if="dialogVisible"
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="searchParams"
        :tabIndexPageReset="false"
        :pager="true"
        :checkBox='true'
        :api="getClassStudentList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        :tableHeight="'500px'"
        :pageSizes="[100, 200, 400, 1000]"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-phone="scope">
          <el-button type="text" @click="handleViewPhone(scope.row, scope.index)">{{ scope.row.phone || '--' }}</el-button>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-isPaper="scope">
          <span v-if="scope.row.isPaper == 1">是</span>
          <span v-else-if="scope.row.isPaper == 2">否</span>
          <span v-else>未知</span>
        </template>
        <template v-slot:col-isSendGraduation="scope">
          <span v-if="scope.row.isSendGraduation == 1">未颁发</span>
          <span v-else-if="scope.row.isSendGraduation == 2">已颁发</span>
          <span v-else>未颁发</span>
        </template>
        <template v-slot:col-isSendQualify="scope">
          <span v-if="scope.row.isSendQualify == 1">未颁发</span>
          <span v-else-if="scope.row.isSendQualify == 2">已颁发</span>
          <span v-else>未颁发</span>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 2 ? '停用' : '启用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-bf="scope">
          <el-button
            v-if="$hasAuthority('tvoperate_awardConformity')"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-watch="scope">
          <el-button
            v-if="scope.data.row.isSendQualify == 2"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
          <span v-else>{{scope.data.item.label}}</span>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="$hasAuthority('tvoperate_deleteConformity')"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
        <template v-slot:bt-print="scope">
          <el-button
            v-if="scope.data.row.isSendQualify === 2 && $hasAuthority('tvoperate_print')"
            :type="'text'"
            :disabled="scope.data.row.synthesize === '不合格' || !scope.data.row.synthesize"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
        <template v-slot:bt-del="scope">
          <el-button
            v-if="$hasAuthority('tvoperate_deleteStudent')"
            :type="'text'"
            @click="removeStudentOne(scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>

      </c-table>
    <div class="btns b-btns">
      <template v-if="showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_deleteConformity_all')" size='mini' type="danger" icon="el-icon-edit" @click="deleteAllCer(2)">删除所有合格证</el-button>
        <el-button v-if="$hasAuthority('tvoperate_deleteCredential_all')" size='mini' type="danger" icon="el-icon-edit" @click="deleteAllCer(1)">删除所有结业证</el-button>
      </template>
      <template v-if="!showOperateAll">
        <el-button v-if="$hasAuthority('tvoperate_deleteConformity_more')" size='mini' type="danger" icon="el-icon-edit" @click="deletepl">批量删除合格证</el-button>
        <el-button v-if="$hasAuthority('tvoperate_deleteCredential_more')" size='mini' type="danger" icon="el-icon-edit" @click="delGraduation">批量删除结业证书</el-button>
      </template>
      <el-button v-if="$hasAuthority('tvoperate_deleteStudent_more')" size='mini' type="danger" icon="el-icon-edit" @click="removeStudent">批量删除学员</el-button>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

  <HandleDateManage ref='dialogDateManage'></HandleDateManage>
  <HandleImportSign ref='dialogImportSign' :importStatus='importStatus' :editParams='editParams' @success='getList'></HandleImportSign>

  <Print ref="print" />
  <HandleCerBf ref='dialogBfSign' :editParams='editNewParams' :studentId='studentId' @success='getList'></HandleCerBf>
</div>
</template>

<script>
import CTable from '@/components/PublicTableCopy';
import DirectRecordSearch from "@/components/Search/index";
import HandleDateManage from "./handle-date-manage";
import HandleImportSign from "./handle-import-sign";
import HandleCerBf from "./handle-cer-bf";
import {
  getClassStudentList,
  delAllGraduation,
  delAllCertificate,
  delCertificate,
  awardCertificate,
  awardAllCertificate,
  removeStudent,
  getPhoneById,
  downloadData
} from '@/api/api'
import  { baseURL } from "@/api/request";
import Print from "./print";
import {
  awardGraduation,
  awardAllGraduation,
  delGraduation,
  awardGraduationAgain,
  exportBatchGraduation,
  exportBatchCertificate,
  exportAllGraduation,
  exportAllCertificate
} from '@/api/faceClass'

export default {
  components: {
    CTable,
    DirectRecordSearch,
    HandleDateManage,
    HandleImportSign,
    HandleCerBf,
    Print
  },
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      getClassStudentList,
      editNewParams:{},
      dialogVisible: false,
      importStatus: 1,
      studentId:'',
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          { label: '序号', value: 'sort' },
          { label: '姓名', value: 'name'},
          { label: '单位', value: 'twoUnit'},
          { label: '部门', value: 'dept' },
          { label: '职务', value: 'position'},
          { label: '纸质证书', value: 'isPaper', type: 'slot' },
          { label: '手机号', value: 'phone', type: 'slot'},
          { label: '综合评定成绩', value: 'synthesize'},
          { label: '合格证套打次数', value: 'playTimes'},
          { label: '结业证颁发状态', value: 'isSendGraduation', type: 'slot'},
          { label: '合格证颁发状态', value: 'isSendQualify', type: 'slot'},
        ],
        handle: {
          label: '操作',
          width: '215',
          btList: [
            { label: '颁发合格证', type: 'text', event: 'bf', show: true, slot: true },
            { label: '删除合格证', type: 'text', event: 'delete', show: true, slot: true },
            // { label: '查看', type: 'text', event: 'edit', show: true },
            { label: '套打合格证', type: 'text', event: 'print', show: true, slot: true },
            { label: '删除学员', type: 'text', event: 'del', show: true, slot: true },
            // { label: '查看合格证', type: 'text', event: 'watch', show: true,slot: true },
          ]
        }
      },
      // 搜索表单配置项
      searchOptions: [
        {
          type: "input",
          label: "学员姓名",
          prop: "name",
          width: "230px",
          placeholder: "请输入学员姓名",
          // querySearchAsync: querySearchAsync,
        },
        {
          type: "input",
          label: "合格证套打次数",
          prop: "playTimes",
          width: "170px",
          placeholder: "请输入合格证套打次数",
          blur: true
        },
        {
          type: "select",
          label: "结业证颁发状态",
          prop: "isSendGraduation",
          width: "150px",
          placeholder: "请选择结业证颁发状态",
          data: [{label: '全部', value: ''}, {label: '未颁发', value: 1}, {label: '已颁发', value: 2}]
        },
        {
          type: "select",
          label: "合格证颁发状态",
          prop: "isSendQualify",
          width: "150px",
          placeholder: "请选择合格证颁发状态",
          data: [{label: '全部', value: ''}, {label: '未颁发', value: 1}, {label: '已颁发', value: 2}]
        },
      ],
      searchParams: {
        playTimes: '',
        isSendGraduation: '',
        isSendQualify: ''
      },
      checkIds:[]
    };
  },
  computed: {
    showOperateAll () {
      if (this.checkIds.length === 0) {
        return true
      }
      return false
    }
  },
  methods: {
    // 批量颁发结业证
    async awardGraduation() {
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      await awardGraduation({ids: this.checkIds.join(), classId: this.editParams.id})
      this.$message.success('颁发成功，请点击“查询”刷新列表数据!')
      this.getList();
    },
    // 全部颁发结业证
    awardGraduationAll(){
      this.$confirm('是否确认为当前班级所有学员颁发结业证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          awardAllGraduation({ classId: this.editParams.id })
            .then(({ code, message }) => {
              if (code === 0) {
                if(message !== 'success'){
                  this.$message.success(message);
                }else{
                  this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
                }
                this.getList();
              } else {
                this.$message.error(message);
              }
            })
        })
    },
    async delGraduation() {
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res = await delGraduation({ids: this.checkIds.join(), classId: this.editParams.id})
          this.$message.success('操作成功!')
          this.getList();
        })
    },
    async awardGraduationAgain() {
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      const res = await awardGraduationAgain({ids: this.checkIds.join(), classId: this.editParams.id})
      this.$message.success('操作成功!')
      this.getList();
    },
    exportBatchGraduation() {
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      downloadData(
        `/radioweb/adm/classStudent/exportBatchGraduation`,
        {
          ids: this.checkIds.join(','),
          classId: this.editParams.id
        }
      )
    },
    showDialog(componentName){
      this.$refs[componentName].setOpacity(true)
    },
    setOpacity(flg) {
      this.dialogVisible = flg;
      this.$nextTick(()=>{
        this.getList();
      })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 查询
    onSearch(data) {},
    importSignTable(status){
      this.importStatus = status;
      this.showDialog('dialogImportSign');
    },
    edit(){
      this.showDialog('dialogDateManage');
    },
    // 通过随机数请求列表
    getList(params) {
      if( params !== 1 ){
        this.searchParams = params ? params : {};
        this.searchParams.classId = this.editParams.id;
      }
      console.log(params)
      console.log(this.searchParams)
      this.tableInfo.refresh = Math.random();
    },
    // table数据
    handleEvent(data,flg) {
      if( !flg){
        this.tableInfo.data = data.records;
      }else{
        if(data){
          let arr = []
          flg.map((item)=>{
            arr.push(item.id);
          })
          this.checkIds = (arr)
        }
      }
    },
    handleClick(event,row){
      if (event === 'edit') {
        this.showDialog('dialogBfSign')
        this.editNewParams = row;
        this.studentId = row.id;
      } else if (event === 'watch') {
        this.showDialog('dialogBfSign')
        let obj = JSON.parse(JSON.stringify(row));
        obj.watch = true
        this.editNewParams = obj;
        this.studentId = row.id;
      } else if (event === 'bf') {
        // console.log('banfa')
        this.showDialog('dialogBfSign')
        this.editNewParams = row;
        this.studentId = row.id;
      } else if (event === 'print') {
        // console.log('banfa')
        this.$refs.print.init(row.qualifyNumber, row.id)
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCertificate({
            classId: this.editParams.id,
            ids: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    async pldc(flg){
      if( !this.checkIds.length ){
        this.$message.error('请选择数据');
        return false;
      }
      let res
      if( flg === 1 ){
        //结业证1  合格2
        res = await exportBatchGraduation({ids: this.checkIds.join(','), classId: this.editParams.id})
      }else{
        res = await exportBatchCertificate({ids: this.checkIds.join(','), classId: this.editParams.id})
      }
      const b = new Blob([res],{
        type: 'application/arraybuffer'
        // type: 'application/vnd.ms-excel'
      })
      //创建一个空的 a 标签
      let a = document.createElement('a');
      // 将 blob 文件转化为 url 格式并赋值给a标签的 href 属性
      a.href = URL.createObjectURL(b)
      // 给a标签设置下载链接并命名
      a.setAttribute('download', flg === 2 ? '合格证信息.xls' : '结业证信息.xls');
      // 点击事件触发 href
      a.click();
      // 清除 a 标签
      a = null
    },
    // 全部导出
    async dcAll(flg){
      let res
      if( flg === 1 ){
        //结业证1  合格2
        res = await exportAllGraduation({ classId: this.editParams.id })
      }else{
        res = await exportAllCertificate({ classId: this.editParams.id })
      }
      const b = new Blob([res],{
        type: 'application/arraybuffer'
        // type: 'application/vnd.ms-excel'
      })
      //创建一个空的 a 标签
      let a = document.createElement('a');
      // 将 blob 文件转化为 url 格式并赋值给a标签的 href 属性
      a.href = URL.createObjectURL(b)
      // 给a标签设置下载链接并命名
      a.setAttribute('download', flg === 2 ? '合格证信息.xls' : '结业证信息.xls');
      // 点击事件触发 href
      a.click();
      // 清除 a 标签
      a = null
    },
    //批量颁发
    plBf(){
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      awardCertificate({
        classId: this.editParams.id,
        ids: this.checkIds.join(',')
      }).then(res => {
        let { code, message } = res;
        if (code === 0) {
          if( message != 'success' ){
            this.$message.success(message);
          }else{
            this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
          }
          this.getList();
        } else {
          this.$message.error(message);
        }
      })
    },
    plBfAll(){
      this.$confirm('是否确认为当前班级所有学员颁发合格证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          awardAllCertificate({ classId: this.editParams.id })
            .then(({ code, message }) => {
              if (code === 0) {
                if(message != 'success'){
                  this.$message.success(message);
                }else{
                  this.$message.success('颁发成功，请点击“查询”刷新列表数据!');
                }
                this.getList();
              } else {
                this.$message.error(message);
              }
            })
        })
    },
    //批量删除
    deletepl(){
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCertificate({
            classId: this.editParams.id,
            ids: this.checkIds.join(',')
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        })

    },
    //批量删除学员
    removeStudent(){
      if( !this.checkIds.length ){
          this.$message.error('请选择数据');
          return false;
      }
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeStudent({
            // classId: this.editParams.id,
            ids: this.checkIds.join(',')
          }).then(res => {
            let { code, message, data } = res;
            if (code === 0) {
              if (data.msg) {
                this.$message.error(data.msg)
              } else {
                this.$message.success('操作成功');
              }
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        })

    },
    //删除单个学员
    removeStudentOne(row){
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeStudent({
            // classId: this.editParams.id,
            ids: row.id
          }).then(res => {
            let { code, message, data } = res;
            if (code === 0) {
              if (data.msg) {
                this.$message.error(data.msg)
              } else {
                this.$message.success('操作成功');
              }
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        })
    },
    deleteAllCer(flg){
      this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if( flg == '1' ){
            delAllGraduation({
                classId: this.editParams.id
              }).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.getList();
                } else {
                  this.$message.error(message);
                }
              })
          }else{
            delAllCertificate({
                classId: this.editParams.id
              }).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.getList();
                } else {
                  this.$message.error(message);
                }
              })
          }
        })
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getPhoneById({ id: row.id }).then(({ code, data }) => {
        if (code === 0) {
          this.tableInfo.data.forEach((item, i) => {
            if (i === index) {
              item.phone = data
            }
          })
        }
      })
    }
  }
};
</script>

<style lang="scss">
.w50{
  width: 50%;
  display: inline-block;
}
.el-dialog__body{
  // max-height: 50vh;
  overflow-y: auto;
}
.btns{
  margin: 10px 0;
}
.b-btns{
  button{
    margin:10px
  }
}
</style>
